import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledIconListProps } from './IconList.types';

export const StyledIcon = styled.span`
  position: absolute;
  top: ${rem('5px')};
  left: 0;
  width: ${rem('22px')};

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const StyledListItem = styled.li`
  position: relative;
  padding-left: ${rem('43px')};
  list-style: none;
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;

  &:not(:last-child) {
    margin-bottom: ${rem('40px')};
  }
`;

export const StyledList = styled.ul<IStyledIconListProps>`
  margin: 0;
  padding: 0;

  ${({ compact }) =>
    compact &&
    `
    ${StyledIcon} {
      width: ${rem('17px')};
    }

    ${StyledListItem} {
      padding-left: ${rem('32px')};

      &:not(:last-child) {
        margin-bottom: ${rem('16px')};
      }
    }
  `}

  ${StyledListItem} {
    color: ${({ theme, wrapped }) =>
      wrapped ? `inherit` : theme.colors.cross.black};
  }
`;
